import { DataAttributeDefinitions } from 'scrivito'

import { pisaProjectDataClass } from './Pisa/pisaProjectDataClass'

const attributes: DataAttributeDefinitions = {}

export const Project = pisaProjectDataClass(attributes)
